export const CHANGE_SCREEN = 'CHANGE_SCREEN';

export const SUBMIT_INQUIRY_REQUEST = 'SUBMIT_INQUIRY_REQUEST';
export const SUBMIT_INQUIRY_SUCCESS = 'SUBMIT_INQUIRY_SUCCESS';
export const SUBMIT_INQUIRY_FAILURE = 'SUBMIT_INQUIRY_FAILURE';
